import React from "react";

const ContactUs = () => {
  return (
    <>
      <div className="">
        <div className="">
          {/* <h1>Contact Us</h1>
          <p>
            For inquiries about our paintings, custom orders,
            <br />
            contact us. We’re here to assist you with all your needs.
          </p> */}
          {/* <img src="./Images/contact-us-tulika.JFIF"/> */}
        </div>
      </div>
      <section className="contact" style={{marginTop: "120px"}}>
        <h2>Contact Us</h2>
        <div className="container">
          <div className="contact-form row">
            <div className="contact-image col-lg-6 mt-3">
              <img src="./Images/contact-us.jpeg" alt="Contact Image" />
            </div>
            <div className="contact-info col-lg-6 mt-3">
              <form action="#" method="POST">
                <div className="form-group">
                  <label htmlFor="name">Name:</label>
                  <input type="text" id="name" name="name" required="" />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email:</label>
                  <input type="email" id="email" name="email" required="" />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Mobile Number:</label>
                  <input type="tel" id="phone" name="phone" required="" />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Description:</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={4}
                    required=""
                    defaultValue={""}
                  />
                </div>
                <button type="submit" className="btn">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
